import { StatusType } from '@/domain/entities/student.entity'

export const formatStatusStudent = (status: StatusType) =>
  ({
    approved: 'Aprovado',
    reproved: 'Reprovado',
    pending: 'Pendente',
    canceled: 'Cancelado',
    processing: 'Em processamento',
  })[status]
